import React from 'react';
import { SecurityOption } from '../profileTypes';
import styles from './SecuritySettings.module.css';

interface SecuritySettingsProps {
  options: SecurityOption[];
  onOptionClick?: (id: string) => void;
}

export const SecuritySettings: React.FC<SecuritySettingsProps> = ({
  options,
  onOptionClick,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <svg viewBox="0 0 24 24" fill="currentColor" className={styles.headerIcon}>
          <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
        </svg>
        <h3 className={styles.title}>Security Settings</h3>
      </div>
      <div className={styles.list}>
        {options.map((option) => (
          <button
            key={option.id}
            className={styles.item}
            onClick={() => onOptionClick?.(option.id)}
          >
            <span className={styles.label}>{option.label}</span>
            <svg viewBox="0 0 24 24" fill="currentColor" className={styles.chevron}>
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
};
